import { ADT } from "pb.adt";

import type { RefundTransactionState } from "./refund-transaction";
import type { SelectTransactionState } from "./select-transaction";

export const State = ADT.define(
	{} as {
		Initialising: true;
		// transaction states
		AwaitTransaction: true;
		AwaitProcessing: {
			isoProcessingCode: string;
			refundAmount: number;
			transactionUuid: string;
		};
		AwaitAccountSelection: { onClose: () => void };
		AwaitApplicationSelection: { onClose: () => void };
		AwaitPinEntry: { onClose: () => void };
		AwaitSignature: { onClose: () => void };
		DisplayPaymentMessage: { onClose: () => void };
		RefundTransaction: RefundTransactionState;
		SelectTransaction: SelectTransactionState;
		SignatureSubmitted: {
			signature?: string;
			onClose: () => void;
			onApprove: () => void;
			onDecline: () => void;
		}; // response states
		Approved: {
			currency?: string;
			totalCents: number;
			onDone: () => void;
		};
		Declined: {
			title: string;
			subtitle?: string;
			message?: string;
			onRetry: () => void;
			onCancel: () => void;
		};
		ErrorDisconnected: { onClose: () => void; onRetry: () => void };
		ErrorFailedToConnectToTerminal: {
			onClose: () => void;
			onRetry: () => void;
		};
		ErrorInactivityTimeout: { onClose: () => void; onRetry: () => void };
		ErrorOperation: { onClose: () => void };
		ErrorNetwork: { onClose: () => void; onRetry: () => void };
		ErrorTerminalBusy: { onClose: () => void; onRetry: () => void };
		ErrorTransactionNotFound: { onClose: () => void };
	},
);

export type State = ADT.define<typeof State>;
